import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, Selection, IColumn, SelectionMode, Panel, Label, TextField, PanelType, CheckboxVisibility, Link } from '@fluentui/react';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { DataService } from "../Services/DataService";
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { IStaalAfname } from '../Interfaces/IStaalAfname';
import { withRouter } from "react-router-dom";
export interface IDisplayStaalAfnameState {
    items: IStaalAfname[];
    itemsService: IStaalAfname[];
    selectionDetails: string;
    selectedItem?: IStaalAfname;
    showPanel: boolean;
}

export class DisplayStaalAfname extends React.Component<any, IDisplayStaalAfnameState> {
    private _columns: IColumn[];
    private _selection: Selection;


    constructor(props: any) {
        super(props);

        initializeIcons(/* optional base url */);
        this._selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this._getSelectionDetails() }),
        });

        this.state = {
            items: [],
            itemsService: [],
            selectionDetails: this._getSelectionDetails(),
            showPanel: false
        };

        this._getStaalAfnameData();

        this._columns = [
            { key: 'Title', name: 'Title', fieldName: 'Title', minWidth: 100, maxWidth: 200, isResizable: true },
            // { key: 'PreId', name: 'PreId', fieldName: 'PreId', minWidth: 100, maxWidth: 200, isResizable: true },
        ];
    }

    private slugify(text: string) {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
}

   async _getStaalAfnameData() {
    var a = await DataService.getStaalAfnameData();

    const titleSlug = this.props.match?.params?.title;

    if (titleSlug) {
        const match = a.find((x: IStaalAfname) =>
            this.slugify(x.Title) === titleSlug.toLowerCase()
        );

        if (match) {
            const item = await DataService.getStaalAfnameItemById(match.Id);
            this.setState({
                items: a,
                itemsService: a,
                selectedItem: item,
                showPanel: false
            });
            return;
        }
    }

    this.setState({ items: a, itemsService: a });
}
    public render(): JSX.Element {
        const { items } = this.state;

        const titleSlug = this.props.match?.params?.title;

if (titleSlug && !this.state.selectedItem) {
    return <div>Loading...</div>;
}

        if (this.props.fullScreen && this.state.selectedItem) {
    return (
        <div>
            

            <h1>{this.state.selectedItem.Title}</h1>

            {this._fieldRender(this.state.selectedItem, "Aard_x0020_prestatie", "Aard prestatie")}
            {this._fieldRender(this.state.selectedItem, "Omschrijving", "Omschrijving")}
            {this._fieldRender(this.state.selectedItem, "Indicaties", "Indicaties")}
            {this._fieldRender(this.state.selectedItem, "Tegenindicaties", "Tegenindicaties")}
            {this._fieldRender(this.state.selectedItem, "Complicaties", "Complicaties")}
            {this._fieldRender(this.state.selectedItem, "Benodigdheden", "Benodigdheden")}
            {this._fieldRender(this.state.selectedItem, "Methodiek_x0020_Voorbereiding", "Methodiek Voorbereiding")}
            {this._fieldRender(this.state.selectedItem, "Methodiek_x0020_Verloop", "Methodiek Verloop")}
            {this._fieldRender(this.state.selectedItem, "Methodiek_x0020_Nazorg", "Methodiek Nazorg")}
            {this._fieldRender(this.state.selectedItem, "Aandachtspunten", "Aandachtspunten")}
            {this._fieldRender(this.state.selectedItem, "Referenties", "Referenties")}
            {this._fieldRender(this.state.selectedItem, "Verantwoordelijke", "Verantwoordelijke")}
            {this._fieldRender(this.state.selectedItem, "PreId", "PreId")}
            {this._fieldRender(this.state.selectedItem, "Version", "Versie")}
            {this._fieldRender(this.state.selectedItem, "Modified", "Gewijzigd op")}

            {this.state.selectedItem?.Bijlagen != null ? <Label>Bijlagen:</Label> : null}
                    {this.state.selectedItem?.Bijlagen?.split(';').map((bijlage: string) => {
                        if (bijlage != "") {
                            var filename = bijlage.substring(bijlage.lastIndexOf('/') + 1);
                            return (<div>
                                <Link 
                                style={{ fontSize: "16px" }}
                                onClick={() => {
                                    fetch(bijlage)
                                        .then(r => r.blob())
                                        .then((blob) => this.showFile(blob, filename))
                                }}
                                >{filename} </Link>
                            </div>
                            );
                        }
                    })}
        </div>
    );
}

        return (
            <div>
                <h1>Staalafname gids</h1>
                <TextField
                    label="Filter by name:"
                    onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                        if (newValue != null) {
                            var lowerValue = newValue.toLowerCase();
                            this.setState({
                                items: newValue ? this.state.itemsService.filter((i: IStaalAfname) =>
                                    i.Title.toLowerCase().indexOf(newValue) > -1
                                    || (i.Omschrijving ? i.Omschrijving : '').toLowerCase().indexOf(lowerValue) > -1
                                ) : this.state.itemsService,
                            });
                        } else {
                            this.setState({ items: this.state.itemsService });
                        }

                    }}
                />
                <DetailsList
                    items={items}
                    columns={this._columns}
                    layoutMode={DetailsListLayoutMode.justified}
                    selection={this._selection}
                    selectionPreservedOnEmptyClick={true}
                    selectionMode={SelectionMode.single}
                    checkboxVisibility={CheckboxVisibility.hidden}
                    compact={true}
                />
                <Panel
                    headerText={this.state.selectedItem != null ? this.state.selectedItem.Title : ""}
                    isOpen={this.state.showPanel}
                    onDismiss={() => {
                        this.setState({ showPanel: false });
                        this._selection.setAllSelected(false);
                    }}
                    isLightDismiss
                    type={PanelType.large}
                    closeButtonAriaLabel="Close"
                >



                    {this._fieldRender(this.state.selectedItem, "Aard_x0020_prestatie", "Aard prestatie")}
                    {this._fieldRender(this.state.selectedItem, "Omschrijving", "Omschrijving")}
                    {this._fieldRender(this.state.selectedItem, "Indicaties", "Indicaties")}
                    {this._fieldRender(this.state.selectedItem, "Tegenindicaties", "Tegenindicaties")}
                    {this._fieldRender(this.state.selectedItem, "Complicaties", "Complicaties")}
                    {this._fieldRender(this.state.selectedItem, "Benodigdheden", "Benodigdheden")}
                    {this._fieldRender(this.state.selectedItem, "Methodiek_x0020_Voorbereiding", "Methodiek Voorbereiding")}
                    {this._fieldRender(this.state.selectedItem, "Methodiek_x0020_Verloop", "Methodiek Verloop")}
                    {this._fieldRender(this.state.selectedItem, "Methodiek_x0020_Nazorg", "Methodiek Nazorg")}
                    {this._fieldRender(this.state.selectedItem, "Aandachtspunten", "Aandachtspunten")}
                    {this._fieldRender(this.state.selectedItem, "Referenties", "Referenties")}
                    {this._fieldRender(this.state.selectedItem, "Verantwoordelijke", "Verantwoordelijke")}
                    {this._fieldRender(this.state.selectedItem, "PreId", "PreId")}
                    {this._fieldRender(this.state.selectedItem, "Version", "Versie")}
                    {this._fieldRender(this.state.selectedItem, "Modified", "Gewijzigd op")}

                    {this.state.selectedItem?.Bijlagen != null ? <Label>Bijlagen:</Label> : null}
                    {this.state.selectedItem?.Bijlagen?.split(';').map((bijlage: string) => {
                        if (bijlage != "") {
                            var filename = bijlage.substring(bijlage.lastIndexOf('/') + 1);
                            return (<div>
                                <Link onClick={() => {
                                    fetch(bijlage)
                                        .then(r => r.blob())
                                        .then((blob) => this.showFile(blob, filename))
                                }}
                                >{filename} </Link>
                            </div>
                            );
                        }
                    })}

                    {this.state.selectedItem && (
    <Link
        onClick={() => {
            const url = `${window.location.origin}/#/Staalafname/${this.slugify(this.state.selectedItem!.Title)}`;
            navigator.clipboard.writeText(url);
            
        }}
    >
        Copy link to item
    </Link>
)}

                    


                </Panel>
            </div>

        );
    }


    private showFile(blob: any, filename: string) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([blob], { type: "application/pdf" })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        const nav = window.navigator as any;

        if (nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(newBlob);
            return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
    }
    private _fieldRender(item: any, fieldName: string, displayName: string) {
        return (
            <div>
                <Label>{displayName}</Label>
                <div className={"content"} dangerouslySetInnerHTML={{ __html: item != null ? item[fieldName] != null && item[fieldName] != "" ? item[fieldName] : "Geen" : "Geen" }} />
            </div>
        )
    }
    private async _setSelectedItem(selectionItem: IStaalAfname) {
        var item = await DataService.getStaalAfnameItemById(selectionItem.Id);
        this.setState({ showPanel: true, selectedItem: item });
    }
    private _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();
        switch (selectionCount) {
            case 0:
                this.setState({ showPanel: false, selectedItem: undefined });
                return "";
            case 1:
                this._setSelectedItem(this._selection.getSelection()[0] as any)
                return "";
            default:
                this.setState({ showPanel: false, selectedItem: undefined });
                return "";
        }
    }

}

export default withRouter(DisplayStaalAfname);
